<template>
  <div
    class="asTypesAuth"
    :class="{
      '-line': shortBtn
    }"
  >
    <a
      v-for="(client) in clients"
      :key="client.name"
      class="-blocked asTypesAuth_btn"
      :class="btnClasses(client)"
      @click="selectTypeAuth(client)"
    >
      <i
        class="asTypesAuth_icon"
        :class="`-${client.name}`"
      />

      <template v-if="!shortBtn">
        {{ getTextBtn(client.name) }}
      </template>
      <div
        v-if="client.linked"
        class="asTypesAuth_unlink"
      />
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import useTypesAuth from '@web/composition/useTypesAuth'

import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'AsTypesAuth',
  props: {
    action: {
      type: String,
      default: 'login'
    },
    shortBtn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  setup (props, ctx) {
    const router = useRouter()
    const {
      onSelectType,
      ...typesAuth
    } = useTypesAuth({ router, action: props.action })

    function selectTypeAuth (client) {
      onSelectType(client)
      ctx.emit('select', client.name)
    }

    function btnClasses (client) {
      const classes: string[] = []
      classes.push(`-${client.name}`)
      if (client.name === 'google') {
        classes.push('-shadow')
      }
      if (client.linked) {
        classes.push('-linked')
      }
      if (props.shortBtn) {
        classes.push('-short')
      }
      return classes
    }

    return {
      ...typesAuth,
      selectTypeAuth,
      btnClasses
    }
  }
})
</script>

<style lang="scss" scoped>
  .asTypesAuth {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;

    &.-line {
      flex-flow: row nowrap;
    }

    &_btn {
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      margin-right: 0;
      margin-bottom: 16px;
      height: 44px;
      width: 100%;
      max-width: 314px;
      border-radius: 24px;
      color: white;
      cursor: pointer;

      &:last-child {
        margin-bottom: 0;
      }

      &.-apple {
        background: #1E1F22;
      }

      &.-google {
        background: #FFFFFF;
        color: #1E1F22;
      }

      &.-facebook {
        background: #667BAF;
      }

      &.-vkontakte {
        background: #4374F0;
      }
    }

    &_unlink {
      position: absolute;
      top: 10px;
      right: 8px;
      height: 24px;
      width: 24px;
      border-radius: 50%;
      background-color: #DD0909;
      background-image: url('~@web/assets/images/icon-close-white.svg');
      background-repeat: no-repeat;
      background-position: center;
    }

    &.-line &_unlink {
      top: -8px;
      right: -8px;
    }

    &.-line &_btn {
      margin-right: 16px;
      margin-bottom: 0;
      max-width: 72px;

      &:last-child {
        margin-right: 0;
      }
    }

    &_icon {
      display: block;
      background-repeat: no-repeat;
      width: 24px;
      height: 24px;
      margin-right: 10px;

      &.-apple {
        width: 16px;
        height: 16px;
        background-image: url(~@web/assets/images/socials/icon-apple-white.svg);
      }

      &.-google {
        background-image: url(~@web/assets/images/socials/icon-google.svg);
      }

      &.-facebook {
        background-image: url(~@web/assets/images/socials/icon-facebook-white.svg);
      }

      &.-vkontakte {
        background-image: url(~@web/assets/images/socials/icon-vk-white.svg);
      }
    }

    &.-line &_icon {
      margin-right: 0;
    }
  }
</style>
